import api from '@/services/api'

export default {
  namespaced: true,
  state: {
    inquiries: {},
    suggestions: {},
    'report.posts': {},
    'report.comments': {}
  },

  actions: {
    markReadAlerts({ dispatch }, type) {
      type = type.replace('.', '_').toUpperCase()
      return new Promise(resolve => {
        api.post(`alerts/mark-all-read?type=${type}`).then(async () => {
          await dispatch('getUnreadAlerts', type)
          resolve()
        })
      })
    },
    // eslint-disable-next-line
    getUnreadAlerts({ }, type) {
      return new Promise(resolve => {
        api.get(`alerts/unread-count?type=${type}`).then(resp => {
          resolve(resp.data.count)
        })
      })
    }
  }
}
